/**
 * @module userParams
 */

/**
 * @param {Cookie} Cookies - Object from Cookies-module
 * @exports module:userParams
 * @return {object}
 */

module.exports = function (Cookies) {

    var getContentGroup = function(prefix) {
        if (typeof dataLayer === 'object') {
            for (var i in dataLayer) {
                if ( dataLayer.hasOwnProperty(i) && dataLayer[i]['ContentGroup']) {
                    return dataLayer[i]['ContentGroup'];
                }
            }
        }

        return null;
    };

    var fill = {
        'data' : {},
        'currentParams': {},

        'setParameters' : function(parameters, urlParams) {
            var param = [],
                params = {},
                value = '';

            params = ( urlParams.length ) ? urlParams.substr(1).split('&') : [];
            for (var i = 0; i < params.length; i++) {
                if (!params[i]) { continue; }

                param = params[i].split('=');
                if (!this.data[param[0]] && parameters.indexOf(param[0]) !== -1) {
                    this.data[param[0]] = decodeURIComponent(param[1]);
                }
            }
            return this.data;
        },
        'setReferrer' : function() {
            if ( !this.data['referrer'] && document.referrer.indexOf(document.location.host) === -1 ) {
                this.data['referrer'] = document.referrer;
            }
            return this.data;
        },
        'setFirstPage' : function() {
            if (!this.data['first_page_url']) {
                this.data['first_page_url'] = document.location.href;
                this.data['first_page_date'] = (new Date()).toUTCString();
                this.data['first_page_group'] = getContentGroup();
            }

            return this.data;
        },
        'setLastPage' : function() {
            this.data['last_page_url'] = document.location.href;
            this.data['last_page_date'] = (new Date()).toUTCString();
            this.data['last_page_group'] = getContentGroup();

            return this.data;
        },
        'setGoogleText' : function() {
            var googleText = (window.performance  &&  window.performance.getEntriesByType('navigation').length) ? performance.getEntriesByType('navigation')[0].name.split('#:~:text=')[1] : "";

            if ( googleText === undefined ) {
                googleText = "";
            }

            this.data['google_text'] = googleText.substr(0, 255);

            return this.data;
        },
        'prepare' : function(previous) {
            this.data = previous || {};

            this.setReferrer();
            this.setFirstPage();
            this.setLastPage();
            this.setGoogleText();

            this.setParameters([
                'utm_source',
                'utm_medium',
                'utm_campaign',
                'utm_term',
                'utm_content'
            ], window.location.search);

            this.setParameters([
                'q', // search query
                'oq', // original search query (google only)
                'pq', // previous search query (bing only)
                'start' //page range, e.g. - '20' means 3rd page (google only)
            ], '?' + (this.data['referrer'] || '').split('?')[1]);

            return this.data;
        }
    };

    const cookieName = 'user',
        data = Cookies.getJSON( cookieName );

    Cookies.create( cookieName, JSON.stringify( fill.prepare( data ) ), '100y', '/' );

    return {};

}; /* module.exports */